import setStateWithReturn from './setStateWithReturn';

export const ERROR_APP_ID = '[REACT]-dwps:';

export default (error) => {
  const onErrorAct = process.env.NODE_ENV === 'test' ? (value) => value : console.error; // eslint-disable-line no-console
  return setStateWithReturn(onErrorAct)(`${ERROR_APP_ID} ${error}`);
};
